const getters = {
    getTaxList(state) {
        return state.taxList;
    },
    getTax(state){
        return state.tax;
    }
};

export default getters;
